module.exports = __webpack_public_path__ + "labioplastika_8_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/labioplastika_8_after.jpg
// module id = 1081
// module chunks = 0